module.exports = __webpack_public_path__ + "img/oufu_140x170x13b.prt.af13c27b.jpg";